/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { BlockquoteBlockData } from './BlockquoteBlockData'
import {
  BlockquoteBlockDataFromJSON,
  BlockquoteBlockDataFromJSONTyped,
  BlockquoteBlockDataToJSON,
} from './BlockquoteBlockData'

/**
 *
 * @export
 * @interface BlockquoteBlock
 */
export interface BlockquoteBlock {
  /**
   *
   * @type {string}
   * @memberof BlockquoteBlock
   */
  type: BlockquoteBlockTypeEnum
  /**
   *
   * @type {BlockquoteBlockData}
   * @memberof BlockquoteBlock
   */
  data: BlockquoteBlockData
}

/**
 * @export
 * @enum {string}
 */
export enum BlockquoteBlockTypeEnum {
  BlockquoteBlock = 'blockquote_block',
}

/**
 * Check if a given object implements the BlockquoteBlock interface.
 */
export function instanceOfBlockquoteBlock(
  value: object
): value is BlockquoteBlock {
  if (!('type' in value) || value['type'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function BlockquoteBlockFromJSON(json: any): BlockquoteBlock {
  return BlockquoteBlockFromJSONTyped(json, false)
}

export function BlockquoteBlockFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): BlockquoteBlock {
  if (json == null) {
    return json
  }
  return {
    type: json['type'],
    data: BlockquoteBlockDataFromJSON(json['data']),
  }
}

export function BlockquoteBlockToJSON(value?: BlockquoteBlock | null): any {
  if (value == null) {
    return value
  }
  return {
    type: value['type'],
    data: BlockquoteBlockDataToJSON(value['data']),
  }
}
